// extracted by mini-css-extract-plugin
export default {"Support":"SupportTooltip_Support__N85Iq","SupportText":"SupportTooltip_SupportText__-tbsc"};